export default __webpack_public_path__ + "static/media/PinClipart.com_ramp-clipart_3220521.5ec86692.png";